<template>
  <tbody>
    <tr v-for="row in rows" :key="'skeleton-row-' + row">
      <td v-for="(column, index) in columns" :key="'skeleton-cell-' + index" class="text-center">
        <div
          v-if="!column.type || column.type === 'text'"
          class="skeleton-base skeleton-shimmer mx-auto"
          :style="{ width: column.width || '80%', height: column.height || '16px' }"
        ></div>

        <div
          v-else-if="column.type === 'circle'"
          class="skeleton-base skeleton-shimmer mx-auto"
          :style="{
            width: column.size || '40px',
            height: column.size || '40px',
            borderRadius: '50%'
          }"
        ></div>

        <div
          v-else-if="column.type === 'badge'"
          class="skeleton-base skeleton-shimmer mx-auto"
          :style="{
            width: column.width || '80px',
            height: column.height || '24px',
            borderRadius: '12px'
          }"
        ></div>

        <div
          v-else-if="column.type === 'actions'"
          class="d-flex justify-content-center gap-2"
        >
          <div
            v-for="n in (column.count || 2)"
            :key="'action-' + n"
            class="skeleton-base skeleton-shimmer"
            :style="{
              width: column.actionWidth || '30px',
              height: column.actionHeight || '30px',
              borderRadius: '4px'
            }"
          ></div>
        </div>

        <div
          v-else-if="column.type === 'avatar-text'"
          class="d-flex align-items-center gap-2 justify-content-center"
        >
          <div
            class="skeleton-base skeleton-shimmer"
            :style="{
              width: column.avatarSize || '40px',
              height: column.avatarSize || '40px',
              borderRadius: '50%',
              flexShrink: 0
            }"
          ></div>
          <div
            class="skeleton-base skeleton-shimmer"
            :style="{
              width: column.textWidth || '150px',
              height: column.textHeight || '16px',
              flexGrow: 1
            }"
          ></div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: 'TableBodySkeleton',

  props: {
    rows: {
      type: Number,
      default: 5
    },

    columns: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
td {
  padding: 12px 8px;
  vertical-align: middle;
}
</style>
